// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d20bf67","453":"252c01b6","455":"a0bccff3","977":"48627448"}[chunkId] + ".chunk.js";
};